import React from 'react';
//import moment from 'moment';
//import { useQuery, Query, renderToStringWithData } from 'react-apollo';
//import gql from 'graphql-tag';
import EventTab from './EventTab';
import EventBlock from './EventBlock';
//import Event from './Event';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';

const eventDays = [
	{
		weekday: "Thursday",
		date: "2021-04-29",
		start: "2021-04-29 00:00:01",
		end: "2021-04-29 23:59:59"
	},
	{
		weekday: "Friday",
		date: "2021-04-30",
		start: "2021-04-30 00:00:01",
		end: "2021-04-30 23:59:59"
	},
	{
		weekday: "Saturday",
		date: "2021-05-01",
		start: "2021-05-01 00:00:01",
		end: "2021-05-01 23:59:59"
	},
];

class EventList extends React.Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.state = { 
			startDate: eventDays[0].start,
			endDate: eventDays[0].end
		};
	}

	handleClick(startDate, endDate) {
		console.log("handling click");
		// todo: make sure I handle tab + enter
		this.setState({
			startDate: startDate,
			endDate: endDate
		});
	}

	render() {
		return (
			<section className="region events" id="when">
				<h2><FontAwesomeIcon icon={faClock} /> Schedule</h2>
				<p className="region-intro">Thursday, April 29 - Saturday, May 1, 2021</p>
				<div className="container">
					<div className="event-schedule">
						<ul className="event-tabs">
							{eventDays.map((day, key) => {
								//const activeDay = moment(this.state.startDate).isBetween(day.start, day.end, null, '[]');
								
								return <EventTab 
								key={key} 
								day={day} 
								onChange={this.handleClick}
								stateDate={this.state.startDate}/>
							})}
						</ul>
						<ul className="event-table-headings">
							<li className="event-time">Time</li>
							<li className="event-title">Event</li>
							<li className="event-location">Location</li>
						</ul>
						<EventBlock start={this.state.startDate} end={this.state.endDate} />
					</div>
				</div>
			</section>	
		)
	}
};

export default EventList;
